





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { startupMaturityList, CEOSuitabilityList, maintenanceStrategyList } from '@/utils/kp';
// import { getSeedKpDetail, getSeedKpList, setKpField, updateKpField } from '@/api/kp';
import { getSimpleKpList } from '@/api/kp';

@Component({})
class projectKpBind extends Vue {
  kpListTmp: any[] = [];
  kpSearchList: any[] = [];

  @Prop()
  kpList;

  @Prop()
  kpListExist;

  created() {
    // console.log('kpInfo', this.kpInfo);
    this.kpListTmp = this.kpList.map(item => {
      return { ...item };
    });
    this.getSimpleKpList('');
  }

  addKp() {
    // this.kpEdit = false;
    this.kpListTmp.push({
      kp: undefined,
      kpId: undefined,
      kpName: undefined,
      position: '' // 职位
    });
  }

  deleteKp(index) {
    this.kpListTmp.splice(index, 1);
  }

  handleKpSearch(value) {
    this.getSimpleKpList(value);
  }

  handleKpChange(value, i) {
    // i.kpName =
    console.log(value, i);
  }

  submit() {
    let flag = this.kpListTmp.find(item => item.kp === undefined);

    if (flag) {
      this.$emit('fail', 'KP字段为空');
      return;
    }

    flag = this.kpListTmp.find(item => item.position === '');
    if (flag) {
      this.$emit('fail', '职位字段为空');
      return;
    }

    // 把kpList中的kp字段解析为kpId和kpName
    this.$emit(
      'success',
      this.kpListTmp.map(item => {
        let tmp = JSON.parse(item.kp);
        item.kpId = tmp.id;
        item.kpName = tmp.name;
        return {
          ...item
        };
      })
    );
  }

  async getSimpleKpList(value) {
    try {
      let res = await getSimpleKpList({
        source: '1,2',
        name: value,
        page: 1,
        pageSize: 100
      });
      if (res.code === 200) {
        // 排除项目已经绑定的KP
        this.kpSearchList = res.data.list.filter(item => {
          if (!item.name) {
            return false;
          }
          return this.kpListExist && this.kpListExist.length > 0 ? !this.kpListExist.find(i => i.baseInfo.id === item.id) : true;
        });
      } else {
        this.$message.error(res.msg);
      }
    } catch (e) {
      console.log(e);

      this.$message.error(e);
    }
    // fetch(value, data => (this.data = data));
  }
}

export default projectKpBind;
